import {Attachment} from '../../core/models';
import {AppealReprocessReason} from '../../admin-config/appeal-reprocess-reasons/appeal-reprocess-reason/appeal-reprocess-reason';

export class RequestToReprocess {
  public appealReProcessReason: AppealReprocessReason;
  public attachment: Attachment;
}
